module.exports = __webpack_public_path__ + "static/img/avatar_pendant.bec5b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar_pendant.png
// module id = 6769097dcbb1243a
// module chunks = 59